import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotSection from "./components/HotSection";
import SupportSection from "./components/SupportSection";
import MerchSection from "./components/MerchSection";
import MeetupSection from "./components/MeetupSection";
import JoinSection from "./components/JoinSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-all hover:bg-primary-600 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50 font-sans">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <HotSection />
        <SupportSection />
        <MerchSection />
        <MeetupSection />
        <JoinSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}